import HamMenu from "../../../components/hamMenu/HamMenu";
import { languageElements } from './TrackingHamMenu-languageElements';

export default function TrackingHamMenu(props) {
    return (
        <HamMenu
            show={props.show}
            languageElements={languageElements}
            menuItems={
                [
                    { itemId: "tracking-system", link: "/tracking/trackingsystem" },
                    { itemId: "yusen-vantage", link: "/tracking/yusenvantage" }
                ]
            } />
    )
}
